import React from 'react';
import { connect } from "react-redux";
import { AppActions, IState, MetaItem, MetaItemPresentation, MetaItemPresentations, MetaItemPresentationValue, MetaItemValue, NewMetaItemValues, PaDocument, PaFile, RevisionCode, RevStatusCode} from '../../types/types'
import Table from '@mui/material/Table';
import TableBody from '@mui/material/TableBody';
import TableCell from '@mui/material/TableCell';
import TableContainer from '@mui/material/TableContainer';
import TableHead from '@mui/material/TableHead';
import TableRow from '@mui/material/TableRow';
import Paper from '@mui/material/Paper';
import MenuItem from '@mui/material/MenuItem';
import TextField from '@mui/material/TextField';
import Button from '@mui/material/Button';
import Switch from '@mui/material/Switch';
import FormControlLabel from '@mui/material/FormControlLabel';
import { revMode } from '../../types/enums';
import Checkbox from '@mui/material/Checkbox';
import { ApplyToAll, LevelChange, metaItemChanged, MetaItemValueChange, onVoidFiles, RevModeChange, SaveClick, setMassUpdateRevisionsVisible } from '../../actions/folderViewActions';
import { ThunkDispatch } from 'redux-thunk';
import BlockOutlinedIcon from '@mui/icons-material/BlockOutlined';

interface RevisionListProps {
        documentList: PaDocument[];
        statusCodes: RevStatusCode[];
        newMetaItemValues: NewMetaItemValues[];
        saveInProgres: boolean;
        revisionCodeValues: RevisionCode[];
        revToUpdate: revMode;
        fileLevelToUpdate: boolean;
        fileMetaItemPresentation: MetaItemPresentations|null;
        fileMetaValidValues: MetaItemPresentationValue[];
        onMetaItemValueChange: (newValue: MetaItemValue) => void;
        onApplyToAll: (value: any, selection: readonly string[]) => void;
        onReload: (requestId:string) => void;
        onRevModeChange: (selectedRevMode:revMode) => void;
        onLevelChange: (value:boolean) => void;
        onSave: ()=> void;
        onVoid: (fiRno: readonly Number[], voidFiles: boolean)=> void;
      }

const RevisionList = (props:RevisionListProps) => {
  const [selected, setSelected] = React.useState<readonly string[]>([]);
  const [selectedFiRno, setSelectedFiRno] = React.useState<readonly Number[]>([]);
  const [dropValues, setDropValues] = React.useState<Record<string, string>[]>([]);

  const fileLevelToUpdateStatic = true;

  const params = new URLSearchParams(window.location.search);
  let requestIdInURL="";
  if(params.has('requestId')) requestIdInURL = params.get('requestId')!;

  const handleValueChange = (key: string, value: string) => {
    let selectedIndex = -1;
    if(dropValues.find(x=>x.key === key) !== undefined)
    {
      selectedIndex = dropValues.indexOf(dropValues.find(x=>x.key === key)!);
    }

    let Selected: Record<string, string> = {key,value};    
    let newSelected:Record<string, string>[] = [];

    if (selectedIndex === -1) {
      newSelected = [Selected].concat(dropValues);
    } else if (selectedIndex === 0) {
      newSelected = [Selected].concat(dropValues.slice(1));
    } else if (selectedIndex === dropValues.length - 1) {
      newSelected = [Selected].concat(dropValues.slice(0, -1));
    } else if (selectedIndex > 0) {
      newSelected = [Selected].concat(
        dropValues.slice(0, selectedIndex),
        dropValues.slice(selectedIndex + 1),
      );
    }

    setDropValues(newSelected);
  };

  const handleClick = (event: React.MouseEvent<unknown>, name: string, fiRno: Number) => {
    const selectedIndex = selected.indexOf(name);
    const selectedIndexFiRno = selectedFiRno.indexOf(fiRno);
    
    let newSelected: readonly string[] = [];
    if (selectedIndex === -1) {
      newSelected = newSelected.concat(selected, name);
    } else if (selectedIndex === 0) {
      newSelected = newSelected.concat(selected.slice(1));
    } else if (selectedIndex === selected.length - 1) {
      newSelected = newSelected.concat(selected.slice(0, -1));
    } else if (selectedIndex > 0) {
      newSelected = newSelected.concat(
        selected.slice(0, selectedIndex),
        selected.slice(selectedIndex + 1),
      );
    }
    setSelected(newSelected);

    //gather fiRno selected
    let newSelectedFiRno: readonly Number[] = [];
    if (selectedIndexFiRno === -1) {
      newSelectedFiRno = newSelectedFiRno.concat(selectedFiRno, fiRno);
    } else if (selectedIndexFiRno === 0) {
      newSelectedFiRno = newSelectedFiRno.concat(selectedFiRno.slice(1));
    } else if (selectedIndexFiRno === selectedFiRno.length - 1) {
      newSelectedFiRno = newSelectedFiRno.concat(selectedFiRno.slice(0, -1));
    } else if (selectedIndexFiRno > 0) {
      newSelectedFiRno = newSelectedFiRno.concat(
        selectedFiRno.slice(0, selectedIndexFiRno),
        selectedFiRno.slice(selectedIndexFiRno + 1),
      );
    }
    setSelectedFiRno(newSelectedFiRno);
    
  };

  const clearSelection = () => {
    let newSelected: readonly string[] = [];
    let newSelectedFiRno: readonly Number[] = [];
    setSelected(newSelected);
    setSelectedFiRno(newSelectedFiRno);
  };

  const isSelected = (name: string) => selected.indexOf(name) !== -1;

  let statusCodes = props.statusCodes.map(status=><MenuItem value={status.Value}>{status.Value} - {status.Description}</MenuItem>);
  statusCodes.unshift(<MenuItem value="">(blank - no status)</MenuItem>)

  return <div>
             <TableContainer component={Paper}>
                <Table size="small" padding="none">
                  <TableRow>
                    <TableCell className="HeaderStatusDrop" colSpan={3}>
                      <FormControlLabel disabled={true} control={<Switch
                          checked={fileLevelToUpdateStatic}
                          onChange={(event)=>{
                                      clearSelection();
                                      props.onLevelChange(event.target.checked);
                                    }
                                  }          
                        />} label="File level" />
                    </TableCell>
                  </TableRow>
                  <TableRow>
                    <TableCell className="HeaderStatusDrop">
                      <TextField select 
                          id="revMode"
                          variant="standard"
                          value={props.revToUpdate}
                          className="HeaderStatusDrop"
                          size="small"
                          label="Rev mode"
                          onChange={(event)=>props.onRevModeChange(event.target.value as any as revMode)}
                          disabled={props.saveInProgres}
                      >
                        <MenuItem value={revMode.LATEST_REV}>Latest revision</MenuItem>
                        <MenuItem value={revMode.CURRENT_REV}>Current revision</MenuItem>
                      </TextField>
                    </TableCell>
                    <TableCell className="AlignBottom">
                    </TableCell>
                    <TableCell>
                    </TableCell>
                  </TableRow>
                  {props.fileLevelToUpdate === true &&
                    <>
                      {
                        props.fileMetaItemPresentation!.MetaItemPresentations.filter(x=>x.Visible === true && x.Enabled === true).map(field=> {
                          return  <TableRow>
                                      { field.ShowDropDownIcon === true &&
                                        <TableCell><TextField select
                                            variant="standard"
                                            defaultValue=""
                                            label={field.LabelText}
                                            size="small"
                                            key={field.Name}
                                            onChange={(event)=> handleValueChange(field.Name, event.target.value)}
                                        >
                                          {[<MenuItem value="">(blank)</MenuItem>].concat(props.fileMetaValidValues.filter(x=> x.MetaItems.filter(y=>y.Name === field.Name).length>0)
                                                                .map(drop=><MenuItem value={drop.Value}>{drop.Value}</MenuItem>))}
                                        </TextField></TableCell>
                                      }
                                      { field.ShowDropDownIcon === false &&
                                        <TableCell><TextField
                                          variant="standard"
                                          defaultValue=""
                                          label={field.LabelText}
                                          size="small"
                                          key={field.Name}
                                          onChange={(event)=> handleValueChange(field.Name, event.target.value)}
                                        /></TableCell>
                                      }
                                      <TableCell className="AlignBottom">
                                        <Button className="MuiButtonMargin" size="small" variant="contained" disabled={props.saveInProgres} onClick={()=> {
                                                  //console.log(dropValues); 
                                                  props.onApplyToAll({DocumentID: "FILE", Attribute: field.Name, Value: dropValues.filter(x=>x.key === field.Name).length>0?dropValues.filter(x=>x.key === field.Name)[0].value:""},selected);
                                                  clearSelection();}}>Apply to all/selected</Button>
                                      </TableCell>
                                      <TableCell>
                                      </TableCell>
                                    </TableRow>
                        }
                        )
                      }
                    <TableRow>
                        <TableCell className="HeaderStatusDrop">  
                        </TableCell>
                        <TableCell>
                        </TableCell>
                        <TableCell width="420" className="AlignBottom">
                            <Button className="MuiButtonMargin" size="small" variant="contained" disabled={props.saveInProgres || selectedFiRno.length===0} onClick={()=>{props.onVoid(selectedFiRno, true); clearSelection()}}>Void selected</Button>
                            <Button className="MuiButtonMargin" size="small" variant="contained" disabled={props.saveInProgres || selectedFiRno.length===0} onClick={()=>{props.onVoid(selectedFiRno, false); clearSelection()}}>UnVoid selected</Button>
                            <Button className="MuiButtonMargin" size="small" variant="contained" disabled={props.saveInProgres} onClick={()=>props.onReload(requestIdInURL)}>Reload list</Button>
                            <Button className="MuiButtonMargin" size="small" variant="contained" onClick={()=>props.onSave()}
                              disabled={
                                  !anyItemHasChanged(props)
                                  ||
                                  props.saveInProgres
                                }
                              >Save files metadata</Button>
                          </TableCell>
                      </TableRow>
                    </>
                  }
                <TableRow className="EmptyRow">
                  <TableCell></TableCell>
                  <TableCell></TableCell>
                  <TableCell></TableCell>
                  </TableRow>
                </Table>
                {props.fileLevelToUpdate === true &&
                  <Table size="small" padding="none" id="FilesList" className="DocumentList">
                        <TableHead>
                          <TableRow className="MuiTblHeaderRow">
                            <TableCell className="resultCell"></TableCell>
                            <TableCell width="10"></TableCell>
                            <TableCell width="10"></TableCell>
                            <TableCell>Filename</TableCell>
                            <TableCell>Org. filename</TableCell>
                              {
                                props.fileMetaItemPresentation!.MetaItemPresentations.filter(x=>x.Visible === true && x.Enabled === true).map(field=> {
                                  return  <><TableCell>{field.LabelText}</TableCell><TableCell>New {field.LabelText}</TableCell></>
                                }
                                )
                              }
                          </TableRow>
                        </TableHead>
                        <TableBody>
                    {props.documentList
                        .sort((a,b) => a.DocId>b.DocId ? 1 : -1)
                        .map(row => {
                            return <>
                              <TableRow>
                                <TableCell colSpan={4 + props.fileMetaItemPresentation!.MetaItemPresentations.filter(x=>x.Visible === true && x.Enabled === true).length * 2}>Document: {row.DocId} - {row.RevisionToUpdate.RevisionCode} - {row.RevisionToUpdate.Status}</TableCell>
                              </TableRow> 
                                          {row.RevisionToUpdate.Files
                                          .sort((a,b) => a.FileRno>b.FileRno ? 1 : -1)
                                          .map( file => {
                                            const isItemSelected = isSelected(file.Name);
                                            return <TableRow  key={file.Name}
                                                            role="checkbox">
                                                      <TableCell className="resultCell">
                                                        {props.newMetaItemValues.filter(x=>
                                                                x.DocumentID === file.Name
                                                                && x.SaveResult !== undefined && x.SaveResult !== "" 
                                                          ).length > 0
                                                          ? props.newMetaItemValues.filter(x=>
                                                              x.DocumentID === file.Name
                                                              && x.SaveResult !== undefined && x.SaveResult !== "" 
                                                            )[0].SaveResult 
                                                          : ""
                                                        }
                                                      </TableCell>
                                                        <TableCell width="10"><Checkbox
                                                          color="primary"
                                                          checked={isItemSelected}
                                                          onClick={(event) => handleClick(event, file.Name, file.FileRno)}
                                                          disabled={props.saveInProgres}
                                                        />
                                                      </TableCell>
                                                      <TableCell width="10">{props.newMetaItemValues.filter(x=>
                                                                        x.DocumentID === file.Name
                                                                        && metaItemChanged(props.newMetaItemValues,file,props.fileLevelToUpdate)
                                                                  ).length > 0
                                                                  ? "*" 
                                                                  : ""
                                                                }</TableCell>
                                                      <TableCell>{file.Status === 3 ? <BlockOutlinedIcon/> : ""} {file.Name}</TableCell>
                                                      <TableCell>{file.OriginalFileName}</TableCell>
                                                      {
                                                        props.fileMetaItemPresentation!.MetaItemPresentations.filter(x=>x.Visible === true && x.Enabled === true).map(field=> {
                                                            return  createField(field, props, file)
                                                          }
                                                        )
                                                      }
                                                  </TableRow>
                                          })}
                            </>

                        })
                      }
                      
                    </TableBody>
                  </Table>
                }
              </TableContainer>
      </div>
      
}

const mapStateToPropsRevisionList = (state:IState) => { 
  return {
   saveInProgres:state.uiState.SAVE_REVISIONS_IsLoading,
   documentList: state.uiItems.documentList,
   statusCodes: state.uiItems.statusCodes,
   newMetaItemValues: state.uiItems.newMetaItemValues,
   revisionCodeValues: state.uiItems.revisionCodeValues,
   revToUpdate: state.uiItems.revToUpdate,
   fileLevelToUpdate: state.uiItems.levelToUpdate,
   fileMetaItemPresentation: state.uiItems.MetaItemPresentations,
   fileMetaValidValues: state.uiItems.MetaItemValidValues
}}

const mapDispatchToPropsRevisionList = (dispatch:ThunkDispatch<IState,undefined,AppActions>)  => ( {
  onMetaItemValueChange: (newValue: MetaItemValue) => dispatch(MetaItemValueChange(newValue)),
  onApplyToAll: (value: any, selection: readonly string[]) => dispatch(ApplyToAll(value, selection)),
  onReload: (requestId:string) => dispatch(setMassUpdateRevisionsVisible(requestId)),
  onSave: () => dispatch(SaveClick()),
  onVoid: (fiRno: readonly Number[], voidFiles: boolean) => dispatch(onVoidFiles(fiRno,voidFiles)),
  onRevModeChange: (value: revMode) => dispatch(RevModeChange(value)),
  onLevelChange: (value: boolean) => dispatch(LevelChange(value)),
})

export default connect(mapStateToPropsRevisionList,mapDispatchToPropsRevisionList)(RevisionList) 

function createField(field:MetaItemPresentation, props:RevisionListProps, row:PaFile)
{
  if(field.ShowDropDownIcon)
  {
    let validValues = props.fileMetaValidValues.filter(x=> x.MetaItems.filter(y=>y.Name === field.Name).length === 1)

    let dropValues = validValues.map(drop=><MenuItem value={drop.Value}>{drop.Value}</MenuItem>);
    dropValues.unshift(<MenuItem value="">(blank)</MenuItem>)

    return <><TableCell>{
                  row.MetaItems.filter(x=>x.Name === field.Name).length>0 ? row.MetaItems.filter(x=>x.Name === field.Name)[0].Value :""
                }</TableCell>
            <TableCell>
              <TextField select
                variant="standard"
                defaultValue=""
                value = {
                          props.newMetaItemValues.filter(x=>x.DocumentID === row.Name && x[field.Name] !== undefined).length > 0  
                          ? props.newMetaItemValues.filter(x=>x.DocumentID === row.Name)[0][field.Name]
                          : null
                        }
                size="small"
                onChange={(event)=>props.onMetaItemValueChange({DocumentID: row.Name, Attribute: field.Name, Value: event.target.value } )}
            >
            {dropValues}
            </TextField></TableCell></>
  }
  else
  {
      return <><TableCell>
        {
                  row.MetaItems.filter(x=>x.Name === field.Name).length>0 ? row.MetaItems.filter(x=>x.Name === field.Name)[0].Value :""
                }</TableCell><TableCell><TextField
        variant="standard"
        defaultValue=""
        size="small"
        value={
              props.newMetaItemValues.filter(x=>x.DocumentID === row.Name && x[field.Name] !== undefined).length > 0  
              ? props.newMetaItemValues.filter(x=>x.DocumentID === row.Name)[0][field.Name]
              : null
            }
        onChange={(event)=>props.onMetaItemValueChange({DocumentID: row.Name,  Attribute: field.Name, Value: event.target.value } )}
      /></TableCell></>
  }
}

function anyItemHasChanged(props:RevisionListProps)
{
  let changed = false;
  let metaItemChanged:any = null;
  let metaItemsToCheck:MetaItem[] = [];
  props.newMetaItemValues.every((meta:NewMetaItemValues)=> {
    metaItemChanged = meta; 
    if(props.fileLevelToUpdate)
    {
      metaItemsToCheck = props.documentList.filter(x=> x.RevisionToUpdate.Files.filter(y=>y.Name ===meta.DocumentID).length>0)[0].RevisionToUpdate.Files.filter(y=>y.Name ===meta.DocumentID)[0].MetaItems;
    }
    else
    {
      metaItemsToCheck = props.documentList.filter(x=> x.DocId === meta.DocumentID)[0].RevisionToUpdate.MetaItems;
    }

    if(metaItemChanged !== null && metaItemChanged !== undefined)
    {
            Object.keys(metaItemChanged).every( key => {
                //console.log("key",key,metaItemChanged[key])
                if(metaItemChanged[key] !== (metaItemsToCheck.filter(x=>x.Name===key).length > 0 ? metaItemsToCheck.filter(x=>x.Name === key)[0].Value : "") && key !=="DocumentID" && key !=="SaveResult" && key !=="NewRevision")
                {
                  changed=true;
                  return false; 
                }
                return true;
            });
    }
    if(changed===true)
    {
      return false;
    }

    return true;
  })
  return changed;
}
  